export default __webpack_public_path__ + "static/media/entenda_2400.71250895.webp";